var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-participants loading-content-container" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "8" } },
                    [
                      _vm.initialFormContexts.participantsAdversary.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-adversary", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsAdversary,
                                },
                                on: {
                                  "reload-participants": _vm.loadParticipants,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsDriverAdversary
                        .isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-driver-adversary", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsDriverAdversary,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsDifferingPolicyholder
                        .isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c(
                                "csp-desktop-participants-differing-policyholder",
                                {
                                  attrs: {
                                    "form-context":
                                      _vm.initialFormContexts
                                        .participantsDifferingPolicyholder,
                                  },
                                }
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsDriverCustomer
                        .isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-driver-customer", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsDriverCustomer,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsPoliceStation.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-police-station", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsPoliceStation,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsWitness.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-witness", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts.participantsWitness,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsInjured.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-injured", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts.participantsInjured,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsInvolvedPerson
                        .isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-involved-person", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsInvolvedPerson,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsDefendant.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-defendant", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsDefendant,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsClaimant.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-claimant", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsClaimant,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsCasualtyLawyer
                        .isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-casualty-lawyer", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsCasualtyLawyer,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsCasualtyAppraiser
                        .isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c(
                                "csp-desktop-participants-casualty-appraiser",
                                {
                                  attrs: {
                                    "form-context":
                                      _vm.initialFormContexts
                                        .participantsCasualtyAppraiser,
                                  },
                                }
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "4" } },
                    [
                      _vm.initialFormContexts.participantsAppraiser.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-appraiser", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsAppraiser,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsExternal.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c(
                                "csp-desktop-participants-external-service-provider",
                                {
                                  attrs: {
                                    "form-context":
                                      _vm.initialFormContexts
                                        .participantsExternal,
                                  },
                                }
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsLawyer.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-lawyer", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts.participantsLawyer,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsCardealer.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-cardealer", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsCardealer,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsDifferingRepairFirm
                        .isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c(
                                "csp-desktop-participants-differing-repair-firm",
                                {
                                  attrs: {
                                    "form-context":
                                      _vm.initialFormContexts
                                        .participantsDifferingRepairFirm,
                                  },
                                }
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsCarRentalCompany
                        .isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c(
                                "csp-desktop-participants-car-rental-company",
                                {
                                  attrs: {
                                    "form-context":
                                      _vm.initialFormContexts
                                        .participantsCarRentalCompany,
                                  },
                                }
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsDSP.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-dsp", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts.participantsDSP,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.initialFormContexts.participantsReseller.isLoaded
                        ? _c(
                            "b-row",
                            { staticClass: "mb-4" },
                            [
                              _c("csp-desktop-participants-reseller", {
                                attrs: {
                                  "form-context":
                                    _vm.initialFormContexts
                                      .participantsReseller,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }